module.exports = __webpack_public_path__ + "img/cells.57304c9a.png";